<template>
    <div class="sidebar">
        <!--- For dynamic purpose (each panel draws its own header with the close button) --->
        <component v-if="component"
                   ref="body"

                   :is="component"
                   :dataPackage="dynamicData"
                   :formData="formData"
                   :permissions="permissions"
                   :siteID="siteID"
                   :formType="formType"

                   @save="save"
                   @saveAndClose="saveAndClose"
                   @close="close"
        />
    </div>
</template>

<script>
    import {EVENT_CONSTANTS} from "../../configs/events";
    import {ALERT_DIALOG} from "../../libraries/alert-dialog";

    const SIDEBAR_WIDTH_SIZE = "300px"

    export default {
        name: "GlobalSidebar",
        props: {
            formData: {
                type: Object,
                default() {
                    return {}
                }
            },
            permissions: Object,
            siteID: String,
            formType: {
                type: String,
                default: null
            }
        },
        data: () => ({
            component: null,
            dynamicData: {},
            runnerId: null,
            isOpen: false,
        }),
        methods: {
            /**
             * Open the Right Sidebar
             */
            open(runnerId) {
                if (this.isOpen) {
                    ALERT_DIALOG.show('Please close the current active sidebar before open another')
                    return
                }

                // set size
                /*
                this.$el.style.width = SIDEBAR_WIDTH_SIZE                
                document.getElementsByTagName("body")[0].style.marginRight = SIDEBAR_WIDTH_SIZE
                */

                let halfWindowSize = window.innerWidth * 0.5 + "px";

                this.$el.style.width = halfWindowSize;
                document.getElementsByTagName("body")[0].style.marginRight = halfWindowSize;

                // turn on flag and notify watcher that sidebar is opened
                // `runnerId` will be sent back in order to make sure other components will touch yours
                this.$formEvent.$emit(EVENT_CONSTANTS.BUILDER.SIDEBAR.OPENED, runnerId)
                this.isOpen = true

                // Esc closes the panel (open() returned early above if it was already open => added once)
                document.addEventListener("keydown", this.onKeydown)
            },

            /**
             * Esc => ask the panel body to close (it confirms first if there are unsaved changes).
             * Leaves Esc alone when something else is using it: a dropdown inside the panel or a modal.
             * @param {KeyboardEvent} e
             */
            onKeydown(e) {
                if (e.key !== "Escape" || e.defaultPrevented || e.repeat) {
                    return
                }

                if (this.$el.querySelector(".multiselect--active") || document.body.classList.contains("modal-open")) {
                    return
                }

                if (this.$refs.body && typeof this.$refs.body.requestClose === "function") {
                    this.$refs.body.requestClose()
                } else {
                    this.close()
                }
            },

            /**
             * Save - Emitting data to the listener but do not close the sidebar
             * @hook Emit Data to the Listener
             */
            save(specialData = {}) {
                this.$formEvent.$emit(
                    EVENT_CONSTANTS.BUILDER.SIDEBAR.SAVE,
                    this.runnerId,
                    Object.assign({}, specialData)
                )
            },

            /**
             * Save event with close the right sidebar
             */
            saveAndClose(specialData = {}) {
                this.$formEvent.$emit(
                    EVENT_CONSTANTS.BUILDER.SIDEBAR.SAVE_AND_CLOSE,
                    this.runnerId,
                    Object.assign({}, specialData)
                )

                this.close()
            },

            /**
             * Close the right sidebar
             * @hook After Closed - Fire an Event to notify (maybe someone will listen :v )
             */
            close() {
                document.removeEventListener("keydown", this.onKeydown)

                this.$el.style.width = 0
                document.getElementsByTagName("body")[0].style.marginRight = 0

                // fire event after closed (if emit == true)
                this.$formEvent.$emit(
                    EVENT_CONSTANTS.BUILDER.SIDEBAR.AFTER_CLOSED,
                    this.runnerId,
                    null
                )

                // remove renderer
                this.component = null
                this.dynamicData = {}
                this.runnerId = null
                this.isOpen = false
            },

            /**
             * This method will help us inject our Component into the Sidebar Body
             * @param {SidebarRenderer} rendererInfo - data that will be assigned for the Component
             */
            updateBody(rendererInfo) {
                if (this.isOpen) {
                    return
                }

                this.dynamicData = Object.assign({}, rendererInfo.data)
                this.component = rendererInfo.component
                this.runnerId = rendererInfo.runnerId
            }
        },

        created() {
            // listen to render even
            this.$formEvent.$on(EVENT_CONSTANTS.BUILDER.SIDEBAR.INJECT, this.updateBody)

            // listen to open
            this.$formEvent.$on(EVENT_CONSTANTS.BUILDER.SIDEBAR.OPEN, this.open)
        },

        beforeDestroy() {
            document.removeEventListener("keydown", this.onKeydown)
        }
    }
</script>
